import langs from "./languages/languages";

export const locales = Object.keys(langs);
export const defaultLocale = "rs";
